import React from "react";
import styles from "./Steps.module.scss";
import { Heading3, Body3 } from "../value-cssmodules/TextComponent";

const Steps = ({ steps: { step, sub } }: any) => {
  return (
    <div className={styles.steps}>
      <Heading3 className={styles.heading}>
        <li>{step}</li>
      </Heading3>
      <Body3 className={styles.paragraph}>{sub}</Body3>
    </div>
  );
};

export default Steps;
